import cns from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Popover, Row } from 'react-bootstrap';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import VerbButton from '../../../../shared/components/VerbButton';

class ArchivePopover extends PureComponent {
    static propTypes = {
        archiveCollection: PropTypes.func.isRequired,
        collectionsStatusById: PropTypes.object,
        collection: PropTypes.object,
        style: PropTypes.object,
        placement: PropTypes.string,
        arrowOffsetLeft: PropTypes.string,
        className: PropTypes.string
    };

    static contextType = RuntimeContext

    render() {
        const { collection, collectionsStatusById, archiveCollection, style, placement, arrowOffsetLeft, className } =
            this.props;

        const currentCollectionStatus = collectionsStatusById[collection._id];
        let archiveSubmissionMessage;
        let associateUserSubscriptionMessage = null;
        let licenscedCompaniesMessage = null;
        let confirmButton = null;

        if (!isEmpty(currentCollectionStatus)) {
            if (currentCollectionStatus.totalSubscriptions > 0) {
                archiveSubmissionMessage = (
                    <p
                        className={'archive-status-message not-ready'}
                    >{`${collection.name} is not ready to be archived!`}</p>
                );
                associateUserSubscriptionMessage = (
                    <div className={'associate-entity-container'}>
                        <Row>
                            <p className={'associated-entity'}>User subscriptions:</p>
                        </Row>
                        <Row>
                            <p className={'collection-name'}>{` - ${currentCollectionStatus.totalSubscriptions} ${
                                currentCollectionStatus.totalSubscriptions > 1 ? 'users are' : 'user is'
                            } currently working on this collection.`}</p>
                        </Row>
                    </div>
                );
            }

            if (currentCollectionStatus.isLicensedByCompany === true) {
                archiveSubmissionMessage = (
                    <p
                        className={'archive-status-message not-ready'}
                    >{`${collection.name} is not ready to be archived!`}</p>
                );
                licenscedCompaniesMessage = (
                    <div className={'associate-entity-container'}>
                        <Row>
                            <p className={'associated-entity'}>Licensed companies:</p>
                        </Row>
                        {currentCollectionStatus.licensedCompanies.map((company) => (
                            <Row>
                                <p className={'company-name'}> - {company.name}</p>
                            </Row>
                        ))}
                    </div>
                );
            }

            if (
                currentCollectionStatus.totalSubscriptions === 0 &&
                currentCollectionStatus.isLicensedByCompany === false
            ) {
                archiveSubmissionMessage = (
                    <p className={'archive-status-message'}>{`${collection.name} is ready to be archived!`}</p>
                );
                confirmButton = (
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        className={'archive-submit-button'}
                        onClick={() => archiveCollection({ body: collection, pathsContext: this.context.pathsWeb })}
                    >
                        OK
                    </VerbButton>
                );
            }
        }
        return (
            <Popover
                style={style}
                id={'archive-submission-popover'}
                className={cns('archive-submission-popover', className)}
                arrowOffsetLeft={arrowOffsetLeft}
                placement={placement}
            >
                {archiveSubmissionMessage}
                {associateUserSubscriptionMessage}
                {licenscedCompaniesMessage}
                <div className={'content-submission-buttons-container'}>{confirmButton}</div>
            </Popover>
        );
    }
}

export default ArchivePopover;
